import { render, staticRenderFns } from "./unpaidShipped.vue?vue&type=template&id=39c96c7f&"
import script from "./unpaidShipped.vue?vue&type=script&lang=js&"
export * from "./unpaidShipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports